/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardViolationsByMonthResponse {
    getFixupPrototypeFunction() { return SecurityDashboardViolationsByMonthResponse.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardViolationsByMonthResponse>): SecurityDashboardViolationsByMonthResponse {
        let obj = Object.assign(new SecurityDashboardViolationsByMonthResponse(), model);
        SecurityDashboardViolationsByMonthResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardViolationsByMonthResponse>): SecurityDashboardViolationsByMonthResponse {
        if (!model) return null;
        return SecurityDashboardViolationsByMonthResponse.newInstance(<SecurityDashboardViolationsByMonthResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardViolationsByMonthResponse) {
        if (!obj) return;

        models.SecurityDashboardViolationsByMonthResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardViolationsByMonthResponse): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardViolationsByMonthResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.summary_by_month) {
            for (let val of this.summary_by_month) {
                models.SecurityDashboardConfigViolationMonth.fixupPrototype(val);
            }
        }
    }

    /**
     * Visibility of the Threats by Month
     */
    summary_by_month: Array<models.SecurityDashboardConfigViolationMonth>;

}
